import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../Sidebar";

interface MainLayoutProps {
  children: React.ReactNode;
}

const pageTitles: { [key: string]: string } = {
  "/dashboard": "Dashboard",
  "/contacts": "Contactos",
  "/certificates": "Certificados",
  "/documents": "Documentos",
  "/dossiers": "Expedientes",
};

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const location = useLocation();

  const getPageTitle = () => {
    return pageTitles[location.pathname] || "Plussigner";
  };

  const handleToggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const footer = (
    <footer className="mt-8 border-t border-slate-200/80 pt-4 text-center text-xs text-slate-500">
      Plussigner v2.0.0, un producto de{" "}
      <a
        href="https://saeta.pe/"
        target="_blank"
        rel="noopener noreferrer"
        className="font-medium text-slate-700 hover:text-slate-900 transition-colors"
      >
        Saeta
      </a>
      .
    </footer>
  );

  return (
    <div className="min-h-screen bg-white">
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={handleToggleSidebar}
      />

      {/* Contenido principal para desktop */}
      <div
        className={`hidden xl:block h-screen transition-all duration-300 ${
          isSidebarCollapsed ? "ml-16" : "ml-64"
        }`}
      >
        <main className="h-full overflow-auto bg-white">
          <div className="p-6 min-h-full">
            <div className="max-w-7xl mx-auto">
              {children}
              {footer}
            </div>
          </div>
        </main>
      </div>

      {/* Vista móvil */}
      <div className="xl:hidden flex flex-col min-h-screen overflow-hidden">
        {/* Top bar móvil */}
        <div className="header-legal flex items-center justify-between h-16 px-4 flex-shrink-0">
          <div className="w-12"></div>
          <h1 className="text-base sm:text-lg font-semibold text-navy text-center truncate">
            {getPageTitle()}
          </h1>
          <div className="w-10"></div>
        </div>

        {/* Page content móvil */}
        <main className="flex-1 overflow-auto bg-white">
          <div className="p-4 min-h-full">
            <div className="max-w-7xl mx-auto">
              {children}
              {footer}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
